const ArchiveStructure = {
  userId: "", // Unique User ID
  userUUID: "",
  userCreated: "",
  profiles: [
    {
      profileId: "",
      archivedOn: "",      // ISO Date-Time string (when archived)
      archivedTill: "",    // ISO Date-Time string (retention until)
      sizeConsumed: 0,     // in KB/MB
      posts: [
        {
          postId: "", // Unique Post ID
          descriptions: "",
          timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
          location: "", // Location of the post
          nlikes: 0, // Number of likes
          medias: [
              {
                  mediatype: "",
                  mediaurl: "",
                  nlikes: 0, // Number of likes
                  likes: [
                    {
                        userId: "",         
                        timestamp: "", // Comment time
                    }
                ],
                comments: [
                  {
                    userId: "", // User who commented
                    comment: "", // Comment text
                    timestamp: "", // Comment time
                    location: "", // Comment location (optional)
                  },
                ],
                nshares: 0, // Number of times shared
                shares: [
                    {
                        userId: "",
                        platform: "",
                        timestamp: "", // Comment time
                    }
                ],
                nsuggests: 0,
                suggests: [
                    {
                        suserId: "",
                        tuserid: "",
                        sprofileid: "",
                        tprofileid: "",         
                        timestamp: "", // Comment time
                    }
                ],
                impressions: 0, // Total number of views/impressions
                nviews: 0,
              }
          ],
          likes: [
              {
                  userId: "",         
                  timestamp: "", // Comment time
              }
          ],
          comments: [
            {
              userId: "", // User who commented
              comment: "", // Comment text
              timestamp: "", // Comment time
              location: "", // Comment location (optional)
            },
          ],
          nshares: 0, // Number of times shared
          shares: [
              {
                  userId: "",
                  platform: "",
                  timestamp: "", // Comment time
              }
          ],
          nsuggests: 0,
          suggests: [
              {
                  suserId: "",
                  tuserid: "",
                  sprofileid: "",
                  tprofileid: "",         
                  timestamp: "", // Comment time
              }
          ],
          impressions: 0, // Total number of views/impressions
          nviews: 0,
        },
      ],
    }
  ]

};

export default ArchiveStructure;
